// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__23FUd","buttons":"RemoveExpirationActionButtons_buttons__2iVvG"};